import {
  IonContent,
  IonPage,
  IonButton,
  IonIcon,
  useIonViewDidEnter,
  useIonViewWillEnter,
} from '@ionic/react';
import React, { useEffect, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './BibleNavigatorPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { BibleBookDetails } from '../../data/BibleBookDetails';
import { BibleBookNames, BibleBookNamesType } from '../../data/BibleBookNames';
import { arrowBack, book } from 'ionicons/icons';
import { BibleGenreNames, BibleGenresValues } from '../../data/BibleGenres';
import { BibleChapterIndex, searchBibleChapterIndex } from '../../data/BibleChapterIndex';
import { useHistory, useParams } from 'react-router';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import { ReadingPlanCodes } from '../../data/ReadingPlans';
import { useSelector } from 'react-redux';
import { SelectBibleColorTheme, SelectLastVersion } from '../../store/BibleStudySlice';
import BibleColorThemes, { BibleColorThemesValues } from '../../data/BibleColorThemes';

const BibleNavigatorPage: React.FC<IRouteInfo> = (props: IRouteInfo) => {
  const history = useHistory();
  const { lastSessionId } = useParams<{ lastSessionId: string;}>();
  const lastSelectedVersion = useSelector(SelectLastVersion);
  const [currentBook, setCurrentBook] = useState<BibleBookNamesType | null>(null);
  const [currentChapter, setCurrentChapter] = useState<number | null>(null);
  const [lastBook, setLastBook] = useState<BibleBookNamesType | null>(null);
  const [lastChapter, setLastChapter] = useState<number | null>(null);
  const bibleColorTheme = useSelector(SelectBibleColorTheme);
  

  useIonViewWillEnter(() => {
    // TO DO: use lastSessionId to highlight last active chapter and verse
    setCurrentBook(null);
    setCurrentChapter(null);
  });

  useEffect(() => {
    if(lastSessionId) {
      const result = searchBibleChapterIndex(+lastSessionId);
      if(result) {
        console.log(`Last Session: ${+lastSessionId} ${result.book} ${result.chapter}`);
        setLastBook(result.book);
        setLastChapter(result.chapter);
      }
    }
  }, [lastSessionId])
  

  const handleBookClick = (book: BibleBookNamesType) => {
    setCurrentBook(book);
    setCurrentChapter(null); // Reset chapter when book changes
  };

  const handleChapterClick = (chapter: number) => {
    setCurrentChapter(chapter);
    const chapterIndex = BibleChapterIndex[currentBook ?? 'GEN'][chapter ?? 1];
    console.log(`Chapter Index: ${chapterIndex}`);
    const chapterUrl = `${AppRouteInfo[AppRouteKeys.Bible].rootPath}/${ReadingPlanCodes.bible}/${chapterIndex}/${lastSelectedVersion}`;
    history.push(chapterUrl, {direction: 'back'})
  };

  const handleBackClick = () => {
    setCurrentBook(null);
  };

  const getColorThemeClass = (colorTheme?: BibleColorThemesValues) => {
    switch(colorTheme) {
      case BibleColorThemes.darkMode:
        return 'bible-navigator-dark-mode';
      default:
        return '';
    }
  }

  // Group books by genre
  const booksByGenre: any = {};
  Object.keys(BibleBookDetails).forEach((book) => {
    const genre = BibleBookDetails[book as BibleBookNamesType].genre;
    if (!booksByGenre[genre]) {
      booksByGenre[genre] = [];
    }
    booksByGenre[genre].push(book as BibleBookNamesType);
  });

  return (
    <IonPage>
      <PageHeader {...props} />
      <IonContent className={`bible-navigator-container ${getColorThemeClass(bibleColorTheme)}`}>
        {currentBook ? (
          <div>
            <div className="bible-navigator-header-container">
              <IonButton mode="md" fill="clear" onClick={handleBackClick} className="bible-navigator-back-button">
                <IonIcon icon={arrowBack} />
              </IonButton>
              <h2 className="bible-navigator-header-title">{BibleBookDetails[currentBook].name}</h2>
            </div>
          <div className={BibleBookDetails[currentBook].chapters < 16 ? 'bible-navigator-chapter-container bible-navigator-chapter-container-small' : 'bible-navigator-chapter-container'}>
            {Array.from({ length: BibleBookDetails[currentBook].chapters }, (_, i) => (
              <div key={i + 1} className="chapter-item">
                <IonButton mode="md"
                  className={currentBook === lastBook && lastChapter === i + 1 ? 'bible-navigator-chapter-selected' : 'bible-navigator-chapter'}
                  onClick={() => handleChapterClick(i + 1)}
                >
                  {i + 1}
                </IonButton>
              </div>
            ))}
          </div>
          </div>
        ) : (
          <div className="book-container">
            {Object.keys(booksByGenre).map((genre) => (
              <div key={genre} className={`genre-row ${BibleGenreNames[+genre as BibleGenresValues].toLowerCase().replace(' ', '-')}`}>
                {booksByGenre[genre].map((book: BibleBookNamesType) => (
                  <div key={book} className="book-item">
                    <div className={lastBook === book ? 'bible-navigator-book-button bible-navigator-selected' : 'bible-navigator-book-button'}
                      onClick={() => handleBookClick(book)}
                    >
                      {book}<br /><span className="bible-navigator-book-name">{BibleBookDetails[book].name}</span>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </IonContent>
    </IonPage>
  );
};

export default BibleNavigatorPage;